import {Box} from '@mui/material';
import './ProtocolIntelligence.scss';
import ProtocolIntelligenceContent from './protocolIntelligenceContent/ProtocolIntelligenceContent';
import ProtocolIntelligenceHeader from './protocolIntelligenceHeader/ProtocolIntelligenceHeader';
import ProtocolIntelligenceFallback from './ProtocolIntelligenceFallback';

const ProtocolIntelligence = ({
  isApiError,
  onProtocolRefreshClick,
}: {
  isApiError: boolean;
  onProtocolRefreshClick: () => void;
}) => {
  return (
    <Box className="manage-protocol-drawer">
      <ProtocolIntelligenceHeader />
      {isApiError ? (
        <ProtocolIntelligenceFallback onRefreshClick={onProtocolRefreshClick} />
      ) : (
        <ProtocolIntelligenceContent />
      )}
    </Box>
  );
};

export default ProtocolIntelligence;
